const base = '/guest';

export const guestLinks = {
  root: () => `${base}`,
  resetPassword: () => `${base}/resetPassword`,
  authentication: () => `${base}/authentication`,
  forgotPassword: () => `${base}/authentication/forgotPassword`,
  forgotPasswordEmail: () => `${base}/authentication/forgotPassword/email`,
  forgotPasswordPhone: () => `${base}/authentication/forgotPassword/phone`,
  register: (role?: string) => `${base}/authentication/register${role ? `?role=${role}` : ''}`,
  registerMenu: () => `${base}/authentication/register/menu`,
  registerEmail: () => `${base}/authentication/register/email`,
  registerPhone: () => `${base}/authentication/register/phone`,
  registerPhoneVerify: () => `${base}/authentication/register/verify`,
  diiaAuth: () => `${base}/authentication/diia`,
  // TODO: this is a legacy use of the /mobile prefix, find a better way to handle this
  projectRegisterMenu: (slug: string) => `/mobile/projects/${slug}/guest/authentication/register`,
  emailVerification: () => `${base}/emailVerification`,
};
